import styled, { css } from 'styled-components';

export const AttachmentContainerStyled = styled.div<{ isImage: boolean }>`
  position: relative;
  display: flex;
  justify-content: center;

  ${({ isImage }) =>
    isImage &&
    css`
      width: 100%;
    `};
`;
